$(document).on('click', '#btn-edit-pt', function () {
  $(this).hide();
  $('#submit-pts').show();
  $('.show-value').hide();
  $('.input-value').show();
  $('.form-pt').find('input').each(function () {
    $(this).prop('disabled', false);
  });
})

$(document).on('click', '#btn-add-pt', function () {
  $('#btn-edit-pt').hide();
  $('#submit-pts').show();
  var timestamp = Date.now();
  let newRow = $('.item-row-template').clone(true);
  newRow.removeClass('item-row-template');
  newRow.addClass('item-row-' + timestamp);
  newRow.find('.edit-pt').hide();
  newRow.find("input").each(function () {
    $(this).prop('disabled', false)
    let name = $(this).attr("name");
    if (name) {
      name = name.replace(/\product_types\[\d+\]/, "product_types[" + timestamp + "]");
      $(this).attr("name", name);
    }
  });
  newRow.find('.remove-row').removeClass('hidden');
  newRow.find('.not-display-on-list').css('margin-top', '5px');
  newRow.show();
  $('.item-row-template').before(newRow);
})

$(document).on('change', '#filter-all', function () {
  const url = new URL(window.location.href);
  if($(this).is(":checked")){
    url.searchParams.set('q[not_display_on_list]', $(this).is(":checked"));
  } else {
    url.searchParams.set('q[not_display_on_list]', $(this).is(":checked"));
  }
  window.location.assign(url.toString());
})

$(document).on("click", ".remove-row", function () {
  $(this).closest(".row").remove();
  
  if ($(".row input[type='text']:visible").length === 0) {
    $('#btn-edit-pt').show();
    $('#submit-pts').hide();
    }
});
